/**
 * KTLife Scroll Reveal — Performance-optimised IntersectionObserver
 * Only animates specific inner elements, NOT broad containers.
 * No will-change, uses rAF batching to avoid scroll jank.
 */

(function () {
  'use strict';

  const REVEAL_CLASS = 'kt-reveal';
  const IN_VIEW_CLASS = 'kt-in-view';

  // NARROW targets only — avoid tagging entire .shopify-section (too many layers)
  const AUTO_TARGETS = [
    '.product-card',
    '.media-with-content__media',
    '.featured-blog-posts__post',
    '.collection-list__item',
    '.kt-promise-item',
    '.testimonial-card',
    '.kt-trust-item',
  ].join(', ');

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const elements = document.querySelectorAll(AUTO_TARGETS);
    if (!elements.length) return;

    // Batch class additions in rAF to avoid layout thrashing during scroll
    const pendingReveal = [];
    let rafPending = false;

    function flushReveal() {
      pendingReveal.forEach((el) => el.classList.add(IN_VIEW_CLASS));
      pendingReveal.length = 0;
      rafPending = false;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            observer.unobserve(entry.target);
            pendingReveal.push(entry.target);
          }
        });

        if (pendingReveal.length && !rafPending) {
          rafPending = true;
          requestAnimationFrame(flushReveal);
        }
      },
      {
        threshold: 0.05,
        rootMargin: '0px 0px -24px 0px',
      }
    );

    const vh = window.innerHeight;
    elements.forEach((el) => {
      const top = el.getBoundingClientRect().top;
      if (top < vh) {
        // Already visible — no animation, just reveal
        el.classList.add(IN_VIEW_CLASS);
      } else {
        el.classList.add(REVEAL_CLASS);
        observer.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
